import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { AppComponent } from '../app.component';
import { ApiRestService } from '../services/api-rest.service';
import { Router } from '@angular/router';
declare var $: any;


@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.css']
})
export class PasswordResetComponent implements OnInit {

	config: any;
	resetpassForm : FormGroup;
	response = {
	    "result": false,
      "status": false,
      "success": false,
      "error": ""
	  };

	email:string;
	username:string;
	click : boolean = true;
  showError : boolean = false;
  constructor(
  		private appComponent: AppComponent,
  	  	private apiRestService: ApiRestService,
  	  	private formBuilder: FormBuilder,
  	  	private router: Router,
  	  	private fb: FormBuilder
  
  	) {
  		this.config = this.appComponent.config;
  		
  	 }

  ngOnInit(): void {
	var vthis = this;
  	this.resetpassForm = this.fb.group({
       email: new FormControl('', [
      Validators.required
    ])
    });
    if(this.resetpassForm.valid) {
    	vthis.click = false;
    }
  }

  resetpass() {
    var vthis = this;
  	if(this.resetpassForm.valid){
  		const reset = {
  		  username: "",
  		  email: this.resetpassForm.value.email,
  		};
      const options = {
                    withCredentials: false
                };
  		this.apiRestService.request('forgotpassword', reset, options).subscribe((response) => {
  		  Object.assign(this.response, response);
        console.log(this.response);
  		  if(this.response.success){
  		      $('#myModal').modal('show');
            $('#myModal').on('hidden.bs.modal', function (e) {
                vthis.router.navigate(['/home']);
            });

  		  }else{
  		  this.showError = true;
  		  }
  		});
  	}
  }
}
